import React from 'react';
import { Icon } from './Icon.js';
export const IconCloudFill12 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "12px", ...props },
        React.createElement("path", { d: "m8.518,3.51c-.749-1.524-2.291-2.51-4.018-2.51C2.019,1,0,3.019,0,5.5s2.019,4.5,4.5,4.5h4.25c1.792,0,3.25-1.458,3.25-3.25,0-1.868-1.563-3.4-3.482-3.24Z", strokeWidth: "0", fill: "currentColor" })));
};
//# sourceMappingURL=IconCloudFill12.js.map